import { Component, OnInit } from '@angular/core';
import { StyleService } from '../../providers/style.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit {

  sideBarOpen = true;
  ApplyPadding = true;

  constructor(
    public StyleControl: StyleService
  ) { }

  ngOnInit() {
    this.StyleControl.DisablePadding$.subscribe(
      Value => {
        if (Value) {
          this.ApplyPadding = false;
        } else {
          this.ApplyPadding = true;
        }
      })
  }

  GetSideBarClass() {
    if (this.ApplyPadding) {
      return 'Cardpadding';
    } else {
      return '';
    }
  }


  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

}
